<template>
  <div />
</template>

<script>
import CustomisedProduct from '~/models/CustomisedProduct'
import { decodeUTF8 } from '~/assets/js/helpers/reviews'

export default {
  props: {
    name: { type: String, required: true },
    sku: { type: String, required: true },
    description: { type: String, required: true },
    baseSku: { type: String, required: true },
    price: { type: [ Number, null ], required: true },
    reviewSummary: { type: Object, required: true },
    currency: { type: String, required: true },
    inStock: { type: Boolean, required: true },
    customisedProduct: { type: CustomisedProduct, required: true }
  },
  computed: {
    review () {
      return this.customisedProduct.product?.pdpConfig?.sampleReview?.[0] || {
        body: ''
      }
    },
    reviewBody() {
      return decodeUTF8(this.review.body || '')
    },
    averageStars() {
      return this.reviewSummary.averageStars
    },
    count() {
      return this.reviewSummary.count
    },
    schema() {
      const schema = {
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: this.name,
        image: this.$dimg.url({ sku: this.sku, w: 800 }),
        description: this.$tr(this.description),
        sku: this.sku,
        mpn: this.sku,
        brand: {
          '@type': 'Brand',
          name: 'SunGod',
        },
        offers: {
          '@type': 'Offer',
          url: `https://www.sungod.co/${this.$route.fullPath}`,
          priceCurrency: this.currency,
          priceValidUntil: '2030-01-01',
          price: this.price,
          itemCondition: 'https://schema.org/NewCondition',
          availability: this.inStock
            ? 'https://schema.org/InStock'
            : 'https://schema.org/OutOfStock',
          seller: {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'SunGod',
            url: 'https://www.sungod.co/',
            sameAs: [
              'https://www.facebook.com/sungodsunglasses',
              'https://www.instagram.com/we_are_sungod',
            ],
          },
        },
      }

      if (this.count) {
        schema.aggregateRating = {
          '@type': 'AggregateRating',
          ratingValue: this.averageStars,
          reviewCount: this.count,
        }
      }

      if (this.reviewBody) {
        schema.review = {
          '@type': 'Review',
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          reviewBody: this.reviewBody,
          author: {
            '@type': 'Person',
            name: this.review.displayName,
          },
        }
      }

      return schema
    },
  },
  jsonld() {
    return this.schema
  },
}
</script>

<style></style>
